import React, { useState } from "react";
import { setNodes, unsetNodes } from "@udecode/plate-core";
import { Transforms } from "slate";
import { getRootProps } from "@udecode/plate-styled-components";

import { ReactEditor, useFocused, useSelected } from "slate-react";
import { LatexInsertComponent } from "../LatexInsertComponent";
import MathRender from "src/components/MathRender";

export const LatexElement = (props: any) => {
    const { attributes, children, element, nodeProps, editor } = props;

    const rootProps = getRootProps(props);

    const { latex } = element;

    const focused = useFocused();
    const selected = useSelected();

    const onChangeLatex = (latex: string) => {
        const path = ReactEditor.findPath(editor as ReactEditor, element);
        // console.log(path);
        setNodes(
            editor,
            {
                latex: latex,
            },
            { at: path },
        );
        // Transforms.insertText(editor, "some words", {
        //   at: { path: path, offset: 3 },
        // });
    };

    const onDeleteLatex = () => {
        const path = ReactEditor.findPath(editor as ReactEditor, element);
        // console.log(path);
        Transforms.delete(editor, { at: path });
    };

    return (
        <div {...attributes} {...rootProps} {...nodeProps}>
            <div
                contentEditable={false}
                // style={{
                //   userSelect: "none",
                //   border: selected ? "1px solid #ACCEF7" : "none",
                // }}
            >
                {selected || !latex ? (
                    <LatexInsertComponent
                        onChange={onChangeLatex}
                        onDelete={onDeleteLatex}
                        value={latex}
                    />
                ) : (
                    <div>
                        <MathRender src={latex} />
                    </div>
                )}
            </div>
            {children}
        </div>
    );
};
